import { Messages } from '../../../../codegen/Localize';

import { selectCatalogingOnSiteEnabled } from '../../../../catalog/selectors/CatalogSelectors';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { IDataQualityAction } from '../../../../ts/ServerApi/types/actionNames';
import { setDataQualityAction } from '../../../actions/spaces/SetDataQualityAction';
import { setDataQualityTriggerAction } from '../../../actions/spaces/SetDataQualityTriggerAction';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { isSingleEmbeddedDatasource } from './IEntityActionHelpers';

export const SetDataQualityAction: IEntityAction<IContentInfo, IDataQualityAction> = {
  name: EntityActionNames.SetDataQuality,
  translateName: Messages.dataQuality_action,
  isVisible: (items, state) => selectCatalogingOnSiteEnabled(state) && !isSingleEmbeddedDatasource(items),
  isClickable: (availableActions: IDataQualityAction) => !!(availableActions && availableActions.updateRemoveDataQuality),
  createReduxAction: (items: IContentInfo[]) => {
    if (!items || items.length === 0 || items.length > 1) {
      throw new Error('setDataQuality was called without exactly one item');
    }

    return setDataQualityAction(items[0]);
  }
};


export const SetDataQualityTriggerAction: IEntityAction<IContentInfo, IDataQualityAction> = {
  name: EntityActionNames.SetDataQualityTrigger,
  translateName: Messages.dataQualityTrigger_action,
  isVisible: (items, state) => FeatureFlags.dqwTriggersEnabled && selectCatalogingOnSiteEnabled(state) && !isSingleEmbeddedDatasource(items),
  isClickable: (availableActions: IDataQualityAction) => !!(availableActions && availableActions.updateRemoveDataQuality),
  createReduxAction: (items: IContentInfo[]) => {
    if (!items || items.length === 0 || items.length > 1) {
      throw new Error('setDataQualityTrigger was called without exactly one item');
    }

    return setDataQualityTriggerAction(items[0]);
  }
};
